import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ClearCreateContractDetails, CreateContract, GetCreateContractDetails } from '../../Services/Actions';
import history from '../../history';
import moment from 'moment';

import { FakeCheckmarkBox, FullNameText, HealthDeclarationContainer, HealthDeclarationOptionsContainer, HealthDeclarationsContainer, HealthDeclarationTextContainer, TermsConditionsContainer } from './styles';
import { ContractParties, DateShortcutCheckbox, DateShortcutContainer, DateShortcutInput, DateShortcutsContainer, DateShortcutSubContainer, DateShortcutTextContainer, DayOptionContainer, DayOptionsContainer, InvoiceAmountContainer, InvoiceContainer, InvoiceDateButtonContainer, InvoiceDateContainer, InvoiceDateSubContainer, InvoicesContainer, MultiSelectRadioButton, OptionalLine, StyledAmountInput, StyledDropdown, StyledHR, StyledInput, StyledInputLabelSideBySide, StyledPaymentNumberPageText, StyledSplitUpInput, UnitListColumnContainer, UnitListColumnSubContainer, UnitOptionsItem, UnitOptionsList, UnitsListContainer, UnitsListRow } from './styles';
import { DetailText, InvoicePreviewAmountContainer, InvoicePreviewContainer, InvoicePreviewDateContainer, InvoicePreviewSubContainer, ProductDescriptionContainer, ProductDescriptionsContainer, ProductsListBlockContainer, ProductsListBlockRowContainer, ProductsListBlocksContainer, ProductsListTableContainer, ProductsListTableRowContainer } from './styles';
import { NonAbelUserInfoModalInformationContainer, SignContractCheckmarkContainer, SignContractContainer, StyledSignContractPageText } from './styles';

import AssignClients from '../../Components/AssignClients';
import ButtonGroup from '../../Components/Buttons/ButtonGroup';
// import ChooseOrganization from '../../Components/ChooseOrganization';
import Loading from '../../Components/Loading';
import MultiText from '../../Components/Text/MultiText';
import PageText from '../../Components/Text/PageText';
import Page from '../../Components/Page';
import Spacer from '../../Components/Spacer';

import ChooseDates from '../../Modals/ChooseDates';
import ChooseOrganization from '../../Modals/ChooseOrganization';
import Info from '../../Modals/Info';

import DeleteX from '../../Assets/Icons/Delete_X.png';
import DeleteX_Gray from '../../Assets/Icons/Delete_X_Gray.png';
import Edit from '../../Assets/Icons/Pencil.png';
import Plus from '../../Assets/Icons/Plus.png';

import { PriceCalculator, RenderCurrencyText, SplitMoney } from '../../Functions';

const FormatMentionText = ({ ClientName, OriginalText, Regex, TrainerName, Values }) => { 
    if (!Values.length) return OriginalText;

    var ReplaceText = { 'CLIENT_FULLNAME': { Props: { UserType: 'Client' }, Text: ClientName }, 'TRAINER_FULLNAME': { Props: { UserType: 'Trainer' }, Text: TrainerName }};

    return (
        <>
            {
                OriginalText.split(Regex).reduce((prev, current, i) => {
                    if (!i) return [current];

                    if (Values.includes(current)) {
                        var ReplacingProps = ReplaceText[current].Props;
                        var ReplacingText = ReplaceText[current].Text;

                        return prev.concat(<FullNameText key={i + current} {...ReplacingProps}>{ReplacingText}</FullNameText>);
                    }

                    return prev.concat(current);
                }, [])
            }
        </>
    );
};

const NonAbelUserContractSteps = [ 'contract_steps_for_non_abel_user_1', 'contract_steps_for_non_abel_user_2', 'contract_steps_for_non_abel_user_3', 'contract_steps_for_non_abel_user_4', 'contract_steps_for_non_abel_user_5' ];

const INITIAL_EDITINGDATE = { DateType: null, InvoiceIndex: null };

var i;
class AddContract extends React.Component {
    _isMounted = false;

    state = {
        AccuracyStatement: '',
        AlreadySelectedProductIds: [],
        ContractCurrency: { CurrencyId: null, CurrencySign: '', SignUsed: null },
        // ContractCurrency: { CurrencyId: 1, CurrencySign: '$', SignUsed: 'After' },
        ContractProducts: {},
        DateShortcuts: { Monthly_NextMonth: { DateNumber: 1 }, Monthly_ThisMonth: { DateNumber: 1 }, Weekly_NextWeek: { NumWeeks: 1, StartingDay: 0 }, Weekly_ThisWeek: { NumWeeks: 1, StartingDay: 0 } },
        DateShortcuts_Selected: null,
        // DateShortcuts_Selected: 'Monthly_ThisMonth',
        DisplayingFilter: null,
        DropdownSize: 0,
        EditingDate: { ...INITIAL_EDITINGDATE },
        InvoicePaymentType: null,
        // InvoicePaymentType: 'SplitUp',
        InvoiceSplitUp: 0,
        // InvoiceSplitUp: 4,
        Invoices_OneTime: [],
        Invoices_SplitUp: [],
        // Invoices_SplitUp: [{ Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }],
        // Invoices_SplitUp: [{ Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-24', PaymentDueDate: '2020-06-30' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-03', PaymentDueDate: '2020-06-10' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-10', PaymentDueDate: '2020-06-16' }, { Amount: 250, AmountText: '$250', InvoiceSentDate: '2020-06-17', PaymentDueDate: '2020-06-23' }],
        Loading: true,
        SelectedOrganization: null,
        SelectedUsers: [],
        SelectedUserIds: [],
        ShowChooseDatesModal: false,
        ShowChooseOrganizationModal: false,
        ShowContractPreview: false,
        ShowNonAbelUserInfoModal: false,
        TermsConditions: '',
        TermsConditions_Original: '',
        TotalInvoicePrice: 0,
        // TotalInvoicePrice: 4000,
        TotalPrice: 0,
        // TotalPrice: 4000,
        TotalPriceText: '0',
        TrainerSigned: false
    };

    componentDidMount() {
        this._isMounted = true;

        this.props.GetCreateContractDetails().then(() => {
            var { t } = this.props;
            var { FirstName, LastName, UserName } = this.props.UserDetails;
            var { AccuracyStatement, Organizations, TermsConditions } = this.props.CreateContractDetails;

            AccuracyStatement = FormatMentionText({ OriginalText: AccuracyStatement, Regex: new RegExp(/\{(.*?)\}/), TrainerName: (FirstName && LastName) ? `${FirstName} ${LastName}` : `@${UserName}`, Values: [ 'TRAINER_FULLNAME' ] });
            TermsConditions = FormatMentionText({ ClientName: t('client_name'), OriginalText: TermsConditions, Regex: new RegExp(/\{(.*?)\}/), TrainerName: (FirstName && LastName) ? `${FirstName} ${LastName}` : `@${UserName}`, Values: [ 'TRAINER_FULLNAME', 'CLIENT_FULLNAME' ] });

            var ShowChooseOrganizationModal = false;
            if (Organizations.length > 0) ShowChooseOrganizationModal = true;

            this.setState({ AccuracyStatement, Loading: false, ShowChooseOrganizationModal, TermsConditions, TermsConditions_Original: TermsConditions });
        });
    }
    
    componentWillUnmount() {
        this._isMounted = false;

        this.props.ClearCreateContractDetails();
    }

    calculateTotalPrice = () => {
        var { ContractCurrency, ContractProducts, InvoiceSplitUp } = this.state;

        var TotalPrice = 0;
        TotalPrice = Object.entries(ContractProducts).map(([ ContractProductsKey, { DiscountAmount, DiscountPercent, DiscountType, Price, Quantity } ]) => PriceCalculator({ DiscountAmount, DiscountPercent, DiscountType, Price, Quantity })).reduce((a, b) => a + b, 0);
        var TotalPriceText = RenderCurrencyText({ CurrencySign: ContractCurrency.CurrencySign, Price: TotalPrice, SignUsed: ContractCurrency.SignUsed });

        // Update Invoices_OneTime To Match
            var Invoices_OneTime = [{ ...this.state.Invoices_OneTime[0], Amount: TotalPrice, AmountText: TotalPriceText }];
            // var TotalInvoicePrice = InvoicePaymentType === 'OneTime' ? TotalPrice : this.state.TotalInvoicePrice;

        TotalPrice = +(TotalPrice.toFixed(2));

        // If Invoices Have
            var Splits = SplitMoney({ NumSplits: +InvoiceSplitUp, TotalPrice });

            // InvoiceIndex In Next Map Will Match Index of Splits
                var Invoices_SplitUp = [ ...this.state.Invoices_SplitUp ];
                Invoices_SplitUp = Invoices_SplitUp.map((Invoice, InvoiceIndex) => ({ ...Invoice, Amount: +Splits[InvoiceIndex], AmountText: RenderCurrencyText({ CurrencySign: ContractCurrency.CurrencySign, Price: +Splits[InvoiceIndex], SignUsed: ContractCurrency.SignUsed }) }));

        this.setState({ Invoices_OneTime, Invoices_SplitUp, TotalInvoicePrice: TotalPrice, TotalPrice, TotalPriceText });
    }

    onAddNewProduct = () => {
        this.setState({
            ContractProducts: {
                ...this.state.ContractProducts,
                NewProduct: { CurrencyId: 0, CurrencyName: '', CurrencySign: '', DiscountAmount: 0, DiscountPercent: 0, DiscountType: null, Price: 0, ProductId: null, ProductName: '', Quantity: 1, SignUsed: '' }
            }
        });
    }

    onAutoUpdateInvoiceDates = () => {
        var { DateShortcuts, DateShortcuts_Selected, InvoicePaymentType, Invoices_OneTime, Invoices_SplitUp } = this.state;

        var InvoiceSentDate_EarlyDays = 3;

        var Invoices = InvoicePaymentType === 'OneTime' ? [ ...Invoices_OneTime ] : [ ...Invoices_SplitUp ];

        var Today = moment().format('YYYY-MM-DD');
        var TodayMonthNumber = moment().month();
        var TodayWeekNumber = moment().isoWeek();

        var InvoiceSentDate, PaymentDueDate;
        var NewMonthNumber, NewWeekNumber, NewYearNumber;
        
        if (DateShortcuts_Selected === 'Monthly_ThisMonth' || DateShortcuts_Selected === 'Monthly_NextMonth') {
            var StartingMonthExtra = DateShortcuts_Selected === 'Monthly_ThisMonth' ? 0 : 1; // Add 1-month to dates if we are starting from next month
            var DateNumber = DateShortcuts[DateShortcuts_Selected].DateNumber;
            if (DateNumber < 10) DateNumber = `0${DateNumber}`;

            Invoices = Invoices.map((Invoice, InvoiceIndex) => {
                // Build New Date
                    NewMonthNumber = (TodayMonthNumber + InvoiceIndex) + 1 + StartingMonthExtra; // 0-indexed in moment
                    if (NewMonthNumber >= 13) {
                        NewMonthNumber = NewMonthNumber % 12;

                        if (NewMonthNumber === 0) NewMonthNumber = 12;
                    }
                    if (NewMonthNumber < 10) NewMonthNumber = `0${NewMonthNumber}`;
                    
                    NewYearNumber = moment(Today).add((InvoiceIndex + StartingMonthExtra), 'months').year();

                    PaymentDueDate = `${NewYearNumber}-${NewMonthNumber}-${DateNumber}`;

                // Date is Invalid (date number is too late for month), so set to last day of month
                    if (!moment(PaymentDueDate).isValid()) PaymentDueDate = `${NewYearNumber}-${NewMonthNumber}-${moment(`${NewYearNumber}-${NewMonthNumber}`, "YYYY-MM").daysInMonth()}`;

                    PaymentDueDate = moment(PaymentDueDate).format('YYYY-MM-DD');

                // If PaymentDueDate < Today, Set To Today
                    if (PaymentDueDate < Today) PaymentDueDate = Today;

                InvoiceSentDate = moment(PaymentDueDate).subtract(InvoiceSentDate_EarlyDays, 'days').format('YYYY-MM-DD');
                // If PaymentDueDate - InvoiceSentDate_EarlyDays < Today, Make InvoiceSentDate Today
                    if (InvoiceSentDate < Today) InvoiceSentDate = Today;

                return ({ ...Invoice, InvoiceSentDate, PaymentDueDate });
            });
        } else if (DateShortcuts_Selected === 'Weekly_ThisWeek' || DateShortcuts_Selected === 'Weekly_NextWeek') {
            var StartingWeekExtra = DateShortcuts_Selected === 'Weekly_ThisWeek' ? 0 : 1; // Add 1-week to dates if we are starting from next week
            var { NumWeeks, StartingDay } = DateShortcuts[DateShortcuts_Selected];

            Invoices = Invoices.map((Invoice, InvoiceIndex) => {
                // Build New Date
                    NewWeekNumber = (TodayWeekNumber + (InvoiceIndex * NumWeeks) + StartingWeekExtra);

                    PaymentDueDate = moment().day(StartingDay + 1).isoWeek(NewWeekNumber);

                    PaymentDueDate = moment(PaymentDueDate).format('YYYY-MM-DD');

                // If PaymentDueDate < Today, Set To Today
                    if (PaymentDueDate < Today) PaymentDueDate = Today;

                InvoiceSentDate = moment(PaymentDueDate).subtract(InvoiceSentDate_EarlyDays, 'days').format('YYYY-MM-DD');
                // If PaymentDueDate - InvoiceSentDate_EarlyDays < Today, Make InvoiceSentDate Today
                    if (InvoiceSentDate < Today) InvoiceSentDate = Today;

                return ({ ...Invoice, InvoiceSentDate, PaymentDueDate });
            });
        }

        this.setState({ [`Invoices_${InvoicePaymentType}`]: Invoices });
    }

    onBlurContractProduct = (event, ContractProductsKey, DataType) => {
        var ContractProducts = { ...this.state.ContractProducts };
        if (!+event.target.value) {
            var NewValue = 1;

            ContractProducts[ContractProductsKey][DataType] = NewValue;

            this.setState({ ContractProducts });
        }
        // Don't allow discount to be more than product price
            else if (DataType === 'DiscountPercent' && +event.target.value > 100) {
                ContractProducts[ContractProductsKey][DataType] = 100;

                this.setState({ ContractProducts }, () => this.calculateTotalPrice());
            }
            else {
                var { DiscountAmount, Price, Quantity } = ContractProducts[ContractProductsKey];

                var TotalPrice = PriceCalculator({ Price, Quantity });
                
                if (+DiscountAmount > +TotalPrice) {
                    ContractProducts[ContractProductsKey].DiscountAmount = +TotalPrice;

                    this.setState({ ContractProducts }, () => this.calculateTotalPrice());
                }
            }
    }

    onBlurDateShortcut = ({ event, DateShortcut }) => {
        // If empty, set as 1
            if (!+event.target.value) {
                var DateShortcuts = { ...this.state.DateShortcuts };
                if (DateShortcut === 'Monthly_ThisMonth' || DateShortcut === 'Monthly_NextMonth') DateShortcuts[DateShortcut].DateNumber = 1;
                else if (DateShortcut === 'Weekly_ThisWeek' || DateShortcut === 'Weekly_NextWeek') DateShortcuts[DateShortcut].NumWeeks = 1;

                this.setState({ DateShortcuts }, () => this.onAutoUpdateInvoiceDates());
            }
        // If too big, and are setting monthly days (not week number), set as 31
            else if (+event.target.value > 31 && (DateShortcut === 'Monthly_ThisMonth' || DateShortcut === 'Monthly_NextMonth')) {
                var NewDateShortcuts = { ...this.state.DateShortcuts };
                NewDateShortcuts[DateShortcut].DateNumber = 31;

                this.setState({ DateShortcuts: NewDateShortcuts }, () => this.onAutoUpdateInvoiceDates());
            }
        else this.onAutoUpdateInvoiceDates();
    }

    onBlurInvoiceAmount = ({ event, InvoiceIndex }) => {
        var NewAmount = ((+event.target.value).toFixed(2));

        var { ContractCurrency, TotalInvoicePrice } = this.state;

        var Invoices_SplitUp = [ ...this.state.Invoices_SplitUp ];
        Invoices_SplitUp[InvoiceIndex].Amount = NewAmount;
        Invoices_SplitUp[InvoiceIndex].AmountText = RenderCurrencyText({ CurrencySign: ContractCurrency.CurrencySign, Price: +NewAmount, SignUsed: ContractCurrency.SignUsed })

        TotalInvoicePrice = +Invoices_SplitUp.map(({ Amount }) => +Amount).reduce((a,b) => a + b, 0).toFixed(2);

        this.setState({ Invoices_SplitUp, TotalInvoicePrice });
    }

    onBlurInvoiceSplitUp = event => {
        if (!+event.target.value) this.setState({ InvoiceSplitUp: 1 }, () => this.onAutoUpdateInvoiceDates());
    }

    onChangeContractProduct = (event, ContractProductsKey, DataType) => {
        var ContractProducts = { ...this.state.ContractProducts };

        ContractProducts[ContractProductsKey][DataType] = event.target.value;
        
        if (DataType === 'DiscountAmount') ContractProducts[ContractProductsKey].DiscountType = 'Amount';
        else if (DataType === 'DiscountPercent') ContractProducts[ContractProductsKey].DiscountType = 'Percentage';

        this.setState({ ContractProducts }, () => this.calculateTotalPrice());
    }

    onChangeDateShortcut = ({ event, DateShortcut }) => {
        var DateShortcuts = { ...this.state.DateShortcuts };
        if (DateShortcut === 'Monthly_ThisMonth' || DateShortcut === 'Monthly_NextMonth') DateShortcuts[DateShortcut].DateNumber = event.target.value;
        else if (DateShortcut === 'Weekly_ThisWeek' || DateShortcut === 'Weekly_NextWeek') DateShortcuts[DateShortcut].NumWeeks = event.target.value;

        this.setState({ DateShortcuts });
    }

    onChangeInvoiceAmount = ({ event, InvoiceIndex }) => {
        var { ContractCurrency, TotalInvoicePrice } = this.state;
        var Amount = +event.target.value;

        var Invoices_SplitUp = [ ...this.state.Invoices_SplitUp ];
        Invoices_SplitUp[InvoiceIndex].Amount = event.target.value;
        Invoices_SplitUp[InvoiceIndex].AmountText = RenderCurrencyText({ CurrencySign: ContractCurrency.CurrencySign, Price: Amount, SignUsed: ContractCurrency.SignUsed })

        TotalInvoicePrice = TotalInvoicePrice - this.state.Invoices_SplitUp[InvoiceIndex].Amount + Amount;

        this.setState({ Invoices_SplitUp, TotalInvoicePrice });
    }

    onChangeInvoiceSplitUp = event => {
        var { ContractCurrency, InvoicePaymentType, TotalPrice, TotalPriceText } = this.state;

        var Invoices = [];
        var InvoiceSplitUp = event.target.value;
        
        var TotalInvoicePrice = TotalPrice;
        if (InvoicePaymentType === 'OneTime') Invoices.push({ Amount: TotalPrice, AmountText: TotalPriceText, InvoiceSentDate: moment().format('YYYY-MM-DD'), PaymentDueDate: moment().add(7, 'days').format('YYYY-MM-DD') });
        else if (InvoicePaymentType === 'SplitUp') {
            var Splits = SplitMoney({ NumSplits: +InvoiceSplitUp, TotalPrice });
            TotalInvoicePrice = 0;

            Invoices = Splits.map((SplitAmount, SplitIndex) => {
                TotalInvoicePrice += +SplitAmount;

                return ({ Amount: SplitAmount, AmountText: RenderCurrencyText({ CurrencySign: ContractCurrency.CurrencySign, Price: +SplitAmount, SignUsed: ContractCurrency.SignUsed }), InvoiceSentDate: moment().add(SplitIndex * 7, 'days').format('YYYY-MM-DD'), PaymentDueDate: moment().add((SplitIndex + 1) * 7, 'days').format('YYYY-MM-DD') });
            });
        }

        TotalInvoicePrice = +(TotalInvoicePrice.toFixed(2));

        this.setState({ [`Invoices_${InvoicePaymentType}`]: Invoices, InvoiceSplitUp, TotalInvoicePrice }, () => +InvoiceSplitUp && this.onAutoUpdateInvoiceDates());
    }

    onClickPreviewContract = () => {
        this.onToggleShowContractPreview(true);
    }

    onCreateContract = () => {
        var { ContractCurrency, ContractProducts, InvoicePaymentType, Invoices_OneTime, Invoices_SplitUp, SelectedUserIds, SelectedOrganization } = this.state;

        if (SelectedOrganization) var BranchId = SelectedOrganization.BranchId;

        var ClientId = SelectedUserIds[0];
        var CurrencyId = ContractCurrency.CurrencyId;

        var Invoices = [];
        if (InvoicePaymentType === 'OneTime') Invoices = Invoices_OneTime;
        else if (InvoicePaymentType === 'SplitUp') Invoices = Invoices_SplitUp;
        
        var PaymentSchedule = Invoices.map(({ Amount, InvoiceSentDate, PaymentDueDate }) => ({ PaymentAmount: Amount, InvoiceSentDate, PaymentDueDate }));
        
        var Products = Object.entries(ContractProducts).map(([ ContractProductsKey, { DiscountAmount, DiscountPercent, DiscountType, ProductId, Quantity } ]) => {
            if (!ProductId) return null;

            return ({ ProductId, ProductQuantity: Quantity, DiscountType: DiscountType || "", Discount: DiscountType === 'Amount' ? DiscountAmount : DiscountPercent });
        });

        var OrganizationBranchId = BranchId;

        this.props.CreateContract({ ClientId, CurrencyId, OrganizationBranchId, PaymentSchedule, Products }).then(() => {
            if (!this.props.TryingCreateContractError) history.push('/sales?tab=contracts');
        });
    }

    onDeleteProduct = (ProductId, ContractProductsKey) => {
        var AfterDeletedContractProducts = { ...this.state.ContractProducts };
        delete AfterDeletedContractProducts[ContractProductsKey];

        var AfterDeletedAlreadySelectedProductIds = [ ...this.state.AlreadySelectedProductIds ];
        if (+ProductId) AfterDeletedAlreadySelectedProductIds.splice(AfterDeletedAlreadySelectedProductIds.indexOf(+ProductId), 1);

        var ContractCurrency = { ...this.state.ContractCurrency };

        // Deleted All Products, Set Contract Currency To Default State
            if (Object.entries(AfterDeletedContractProducts).length === 0) ContractCurrency = { CurrencyId: null, CurrencySign: '', SignUsed: null };

        this.setState({ AlreadySelectedProductIds: AfterDeletedAlreadySelectedProductIds, ContractCurrency, ContractProducts: AfterDeletedContractProducts }, () => this.calculateTotalPrice());
    }

    onGetSize = Height => {
        this.setState({ DropdownSize: Height });
    }

    onSelectClients = ({ SelectedClients: SelectedUsers }) => {
        if (SelectedUsers.length) {
            var { SelectedUserIds } = this.state;

            if (SelectedUserIds[0] !== +SelectedUsers[0].UserId) {
                var SelectedUserIds_New = SelectedUsers.map(User => User.UserId);
                var { FirstName, LastName, UserName } = this.props.UserDetails;
                var { TermsConditions } = this.props.CreateContractDetails;

                TermsConditions = FormatMentionText({ ClientName: SelectedUsers[0].DisplayName, OriginalText: TermsConditions, Regex: new RegExp(/\{(.*?)\}/), TrainerName: (FirstName && LastName) ? `${FirstName} ${LastName}` : `@${UserName}`, Values: [ 'TRAINER_FULLNAME', 'CLIENT_FULLNAME' ] });

                this.setState({ SelectedUsers, SelectedUserIds: SelectedUserIds_New, TermsConditions });
            }
        } else this.setState({ SelectedUsers: [], SelectedUserIds: [], TermsConditions: this.state.TermsConditions_Original });
    }

    onSelectContractProductDiscountType = ({ ContractProductsKey, DiscountType }) => {
        var ContractProducts = { ...this.state.ContractProducts };

        var NewDiscountType = DiscountType;
        if (ContractProducts[ContractProductsKey].DiscountType === DiscountType) NewDiscountType = null;

        ContractProducts[ContractProductsKey].DiscountType = NewDiscountType;

        this.setState({ ContractProducts }, () => this.calculateTotalPrice());
    }

    onSelectDates = SelectedDates => {
        var { EditingDate: { DateType, InvoiceIndex }, InvoicePaymentType } = this.state;

        if (this.state[`Invoices_${InvoicePaymentType}`][InvoiceIndex][DateType] !== SelectedDates[0].substring(0,10)) {
            var NewInvoices = [ ...this.state[`Invoices_${InvoicePaymentType}`] ];
            NewInvoices[InvoiceIndex][DateType] = SelectedDates[0].substring(0,10);

            this.setState({ EditingDate: { ...INITIAL_EDITINGDATE }, [`Invoices_${InvoicePaymentType}`]: NewInvoices, ShowChooseDatesModal: false });
        }
        else this.setState({ EditingDate: { ...INITIAL_EDITINGDATE }, ShowChooseDatesModal: false });
    }

    onSelectDateShortcut = DateShortcut => {
        var { DateShortcuts_Selected } = this.state;

        var NewDateShortcut = null;
        if (DateShortcut !== DateShortcuts_Selected) NewDateShortcut = DateShortcut;

        this.setState({ DateShortcuts_Selected: NewDateShortcut }, () => {
            // If NewDateShortcut, then rebuild invoice dates
                if (NewDateShortcut) this.onAutoUpdateInvoiceDates();
        });
    }

    onSelectOrganization = SelectedOrganization => {
        this.setState({ SelectedOrganization, ShowChooseOrganizationModal: false });
    }

    onSelectProduct = ({ ContractProductsKey, ProductId, ProductIndex }) => {
        var NewContractProducts = { ...this.state.ContractProducts };
        var NewAlreadySelectedProductIds = [ ...this.state.AlreadySelectedProductIds ];

        var SelectedProductDetails = { ...this.props.CreateContractDetails.Products[ProductIndex] };

        if (ContractProductsKey === 'NewProduct') {
            ContractProductsKey = `ProductId-${ProductId}`;
            NewContractProducts[ContractProductsKey] = { ...NewContractProducts.NewProduct };
            delete NewContractProducts.NewProduct;
        } else NewAlreadySelectedProductIds.splice(NewAlreadySelectedProductIds.indexOf(+ProductId), 1);

        NewAlreadySelectedProductIds.push(+ProductId);

        var ContractCurrency = { ...this.state.ContractCurrency };

        // Selected First Product, Set Contract Currency To It
            if (Object.entries(NewContractProducts).length === 1) {
                var { CurrencyId, CurrencySign, SignUsed } = SelectedProductDetails;
                ContractCurrency = { CurrencyId, CurrencySign, SignUsed };
            }

        NewContractProducts[ContractProductsKey] = { ...NewContractProducts[ContractProductsKey], ...this.state.ContractProducts[ContractProductsKey], ProductId, ...SelectedProductDetails };

        this.setState({ AlreadySelectedProductIds: NewAlreadySelectedProductIds, ContractCurrency, DisplayingFilter: null, ContractProducts: NewContractProducts }, () => this.calculateTotalPrice());
    }

    onSelectWeekStartingDay = ({ DateShortcut, DayIndex }) => {
        var DateShortcuts = { ...this.state.DateShortcuts };

        if (DateShortcuts[DateShortcut].StartingDay !== DayIndex) {
            DateShortcuts[DateShortcut].StartingDay = DayIndex;

            this.setState({ DateShortcuts }, () => this.onAutoUpdateInvoiceDates());
        }
    }

    onToggleDropdown = (DisplayingFilter, ToggleStatus) => {
        this.setState({ DisplayingFilter: ToggleStatus ? DisplayingFilter : null });
    }

    onToggleInvoicePaymentType = InvoicePaymentType => {
        if (this.state.InvoicePaymentType !== InvoicePaymentType) {
            var { TotalPrice, TotalPriceText } = this.state;

            var Invoices_OneTime = [ ...this.state.Invoices_OneTime ];
            if (InvoicePaymentType === 'OneTime') Invoices_OneTime = [{ Amount: TotalPrice, AmountText: TotalPriceText, InvoiceSentDate: moment().format('YYYY-MM-DD'), PaymentDueDate: moment().add(7, 'days').format('YYYY-MM-DD') }];

            var TotalInvoicePrice = InvoicePaymentType === 'OneTime' ? TotalPrice : +this.state.Invoices_SplitUp.map(({ Amount }) => +Amount).reduce((a,b) => a + b, 0).toFixed(2);

            this.setState({ InvoicePaymentType, Invoices_OneTime, TotalInvoicePrice, TotalPrice, TotalPriceText });
        }
    }

    onToggleShowChooseDatesModal = ({ EditingDate, ShowChooseDatesModal }) => {
        this.setState({ EditingDate, ShowChooseDatesModal });
    }

    onToggleShowChooseOrganizationModal = ShowChooseOrganizationModal => {
        this.setState({ ShowChooseOrganizationModal });
    }

    onToggleShowContractPreview = ShowContractPreview => {
        this.setState({ ShowContractPreview }, window.scrollTo(0,0));
    }

    onToggleShowNonAbelUserInfoModal = ShowNonAbelUserInfoModal => {
        this.setState({ ShowNonAbelUserInfoModal });
    }

    onToggleTrainerSigned = () => {
        this.setState({ TrainerSigned: !this.state.TrainerSigned });
    }

    renderContractPreview = () => {
        var { t } = this.props;
        var { FirstName, LastName, UserName } = this.props.UserDetails;
        var { SelectedOrganization, SelectedUsers, TrainerSigned } = this.state;

        var ContractPartiesText = FormatMentionText({ ClientName: SelectedUsers[0].DisplayName, OriginalText: t('contract_parties_in_deal'), Regex: new RegExp(/\{(.*?)\}/), TrainerName: (FirstName && LastName) ? `${FirstName} ${LastName}` : `@${UserName}`, Values: [ 'TRAINER_FULLNAME', 'CLIENT_FULLNAME' ] });

        return (
            <>
                <ContractParties>{ContractPartiesText}</ContractParties>

                <Spacer Size="extra-small" />

                <MultiText
                    Texts={[
                        { FontFamily: 'semibold', FontSize: 'medium-1', Text: `${t('Date_str')}:` },
                        { FontFamily: 'medium', FontSize: 'medium-1', Text: moment().format('[WeeklyViewHeader]') }
                    ]}
                />

                {
                    SelectedOrganization !== null &&
                    <>
                        <Spacer Size="medium" />

                        <MultiText
                            Texts={[
                                { FontFamily: 'medium', FontSize: 'medium-1', Text: `${t('collaboration_with')}:` },
                                { FontFamily: 'semibold', FontSize: 'medium-1', Text: SelectedOrganization.OrgId === 0 ? t('none_with_first_char_uppercase') : `${SelectedOrganization.OrgName} - ${SelectedOrganization.BranchName}` }
                            ]}
                        />
                    </>
                }

                <Spacer Size="medium" />

                <StyledHR />

                <Spacer Size="medium" />

                {this.renderProductsPreview()}

                <Spacer Size="medium" />

                <StyledHR />

                <Spacer Size="medium" />

                {this.renderInvoicesPreview()}

                <Spacer Size="medium" />

                <StyledHR />

                <Spacer Size="medium" />

                {this.renderLegal()}

                <Spacer Size="medium" />

                <StyledHR />

                <Spacer Size="medium" />

                <SignContractContainer>
                    <SignContractCheckmarkContainer className="SignContractCheckmarkContainer" onClick={this.onToggleTrainerSigned} Selected={TrainerSigned} />
                    
                    <StyledSignContractPageText FontFamily="medium" FontSize="medium-2" JustifyContent="flex-start" NoMargin OnClick={this.onToggleTrainerSigned} Text={t('contract_agree_to_sign')} TextAlign="left" />
                </SignContractContainer>
            </>
        );
    }

    renderContractProductOptions = (ProductId, ContractProductsKey) => {
        var { AlreadySelectedProductIds, ContractCurrency: { CurrencyId: ContractCurrencyId }, ContractProducts } = this.state;

        return (
            <UnitOptionsList>
                {
                    this.props.CreateContractDetails.Products.map(({ CurrencyId, ProductId: OptionsProductId, ProductName }, ProductIndex) => {
                        OptionsProductId = +OptionsProductId;
                        var Selected = +ProductId === OptionsProductId;
                        var Disabled = (AlreadySelectedProductIds.indexOf(OptionsProductId) !== -1 && !Selected) || (Object.entries(ContractProducts).length > 1 && +ContractCurrencyId && +CurrencyId !== +ContractCurrencyId);

                        return (
                            <UnitOptionsItem key={OptionsProductId} Disabled={Disabled} onClick={Disabled ? () => null : () => this.onSelectProduct({ ContractProductsKey, ProductId: OptionsProductId, ProductIndex })} Selected={Selected}>
                                <PageText FontFamily="medium" FontSize="small" JustifyContent="flex-start" NoMargin Text={ProductName} TextAlign="left" />
                            </UnitOptionsItem>
                        );
                    })
                }
            </UnitOptionsList>
        );
    }

    renderContractProducts = () => {
        var { t } = this.props;
        var { Device } = this.props;
        var { ContractProducts, DisplayingFilter, DropdownSize, TotalPriceText } = this.state;

        return (
            <>
                <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text={t('products_select')} TextAlign="center" />

                <Spacer Size="extra-small" />

                {
                    Object.entries(ContractProducts).length ?
                        <UnitsListContainer className="UnitsListContainer">
                        {Device === 'laptop' && this.renderContractProductsHeaderRow()}

                        {
                            Object.entries(ContractProducts).map(([ ContractProductsKey, { CurrencySign, DiscountAmount, DiscountPercent, DiscountType, Price, ProductId, ProductName, Quantity, SignUsed } ]) => {
                                var ReadOnly = !!!+ProductId; // If it is a new product, that hasn't had Product selected yet
                                
                                var TotalProductPrice = PriceCalculator({ DiscountAmount, DiscountPercent, DiscountType, Price, Quantity });

                                return (
                                    <UnitsListRow key={ProductId}>
                                        <UnitListColumnContainer>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('product_select')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <StyledDropdown
                                                ContentRenderer={() => this.renderContractProductOptions(ProductId, ContractProductsKey)}
                                                Disabled={false}
                                                ForceClose={DisplayingFilter !== ContractProductsKey}
                                                GetSize={Height => this.onGetSize(Height)}
                                                Height={DisplayingFilter === ContractProductsKey && DropdownSize}
                                                IsList={false}
                                                IsMobile={Device === 'mobile_small' || Device === 'mobile'}
                                                ItemId="Units"
                                                NeedsToLoad={false}
                                                OnToggleDropdown={ToggleStatus => this.onToggleDropdown(ContractProductsKey, ToggleStatus)}
                                                SelectedItemIds={[]}
                                                Title={ProductName || t('product_select')}
                                                TitleFontColor={ProductName ? 'blue-astronaut' : null}
                                                TitleFontFamily="semibold"
                                                TitleIcon={Device !== 'laptop' ? DeleteX : DeleteX_Gray}
                                                TitleIconOnHover={Device !== 'laptop' ? null : DeleteX}
                                                TitleIconOnClick={() => this.onDeleteProduct(ProductId, ContractProductsKey)}
                                            />
                                        </UnitListColumnContainer>
                                        <UnitListColumnContainer>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('Quantity')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <StyledInput
                                                FontFamily="medium"
                                                FontSize="medium-1"
                                                NoDecimal
                                                NoLabel
                                                NoMargin
                                                OnBlur={event => this.onBlurContractProduct(event, ContractProductsKey, 'Quantity')}
                                                OnChange={event => this.onChangeContractProduct(event, ContractProductsKey, 'Quantity')}
                                                Placeholder="0"
                                                ReadOnly={ReadOnly}
                                                Type="number"
                                                Value={Quantity}
                                            />
                                        </UnitListColumnContainer>
                                        <UnitListColumnContainer>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('Price')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <PageText FontColor={ReadOnly ? 'white-concrete' : 'black'} FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text={RenderCurrencyText({ CurrencySign, Price, SignUsed })} TextAlign="center" />
                                        </UnitListColumnContainer>
                                        <UnitListColumnContainer RowFlex>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('discount_percent')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <UnitListColumnSubContainer>
                                                <MultiSelectRadioButton onClick={ReadOnly ? () => null : () => this.onSelectContractProductDiscountType({ ContractProductsKey, DiscountType: 'Percentage' })} ReadOnly={ReadOnly} Selected={DiscountType === 'Percentage'} />
                                                <StyledInputLabelSideBySide
                                                    InputFontFamily="medium"
                                                    InputFontSize="medium-1"
                                                    InputWidth="100%"
                                                    LabelFontFamily="medium"
                                                    LabelFontSize="medium-1"
                                                    Label="%"
                                                    OnBlur={event => this.onBlurContractProduct(event, ContractProductsKey, 'DiscountPercent')}
                                                    OnChange={event => this.onChangeContractProduct(event, ContractProductsKey, 'DiscountPercent')}
                                                    Placeholder="0"
                                                    ReadOnly={ReadOnly || DiscountType !== 'Percentage'}
                                                    ReadOnly1={ReadOnly}
                                                    Type="number"
                                                    Value={DiscountType === 'Percentage' ? DiscountPercent : 0}
                                                />
                                            </UnitListColumnSubContainer>
                                        </UnitListColumnContainer>
                                        <UnitListColumnContainer RowFlex>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('discount_amount')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <UnitListColumnSubContainer>
                                                <MultiSelectRadioButton onClick={ReadOnly ? () => null : () => this.onSelectContractProductDiscountType({ ContractProductsKey, DiscountType: 'Amount' })} ReadOnly={ReadOnly} Selected={DiscountType === 'Amount'} />
                                                <StyledInputLabelSideBySide
                                                    InputFontFamily="medium"
                                                    InputFontSize="medium-1"
                                                    InputWidth="100%"
                                                    LabelFontFamily="medium"
                                                    LabelFontSize="medium-1"
                                                    Label={CurrencySign}
                                                    OnBlur={event => this.onBlurContractProduct(event, ContractProductsKey, 'DiscountAmount')}
                                                    OnChange={event => this.onChangeContractProduct(event, ContractProductsKey, 'DiscountAmount')}
                                                    Placeholder="0"
                                                    ReadOnly={ReadOnly || DiscountType !== 'Amount'}
                                                    ReadOnly1={ReadOnly}
                                                    Type="number"
                                                    Value={DiscountType === 'Amount' ? DiscountAmount : 0}
                                                />
                                            </UnitListColumnSubContainer>
                                        </UnitListColumnContainer>
                                        <UnitListColumnContainer>
                                            {Device !== 'laptop' && <><PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('total_price')} TextAlign="center" /><Spacer Size="extra-extra-small" /></>}

                                            <PageText FontFamily="bold" FontSize="medium-3" JustifyContent="center" NoMargin Text={`${RenderCurrencyText({ CurrencySign, Price: TotalProductPrice, SignUsed })}`} TextAlign="center" />
                                        </UnitListColumnContainer>

                                        {/* Show hr line between each product */}
                                        {Device !== 'laptop' && (ContractProductsKey !== Object.keys(ContractProducts)[Object.keys(ContractProducts).length - 1]) && <StyledHR />}
                                    </UnitsListRow>
                                );
                            })
                        }

                        <UnitsListRow>
                            <ButtonGroup
                                Buttons={[{ FontFamily: 'semibold', Icon: Plus, IconPosition: 'left', OnClick: this.onAddNewProduct, Title: t('product_add') }]}
                                ButtonWidth={Device === 'mobile' || Device === 'mobile_small' ? null : 'fit-content'}
                                NotTouching
                                OwnRows={Device === 'mobile' || Device === 'mobile_small' ? true : false}
                            />
                        </UnitsListRow>
                    </UnitsListContainer>
                :
                    <ButtonGroup
                        Buttons={[{ FontFamily: 'semibold', Icon: Plus, IconPosition: 'left', OnClick: this.onAddNewProduct, Title: t('product_add') }]}
                        ButtonWidth={Device === 'mobile' || Device === 'mobile_small' ? null : 'fit-content'}
                        NotTouching
                        OwnRows={Device === 'mobile' || Device === 'mobile_small' ? true : false}
                    />
                }

                <Spacer Size="medium" />

                {
                    !!+Object.entries(ContractProducts).length &&
                    <>
                        <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text={t('total_price')} TextAlign="center" />
                        
                        <PageText FontColor="blue-abel" FontFamily="bold" FontSize="medium-3" JustifyContent="center" NoMargin Text={TotalPriceText} TextAlign="center" Underline />
                    </>
                }
            </>
        );
    }

    renderContractProductsHeaderRow = () => {
        var { t } = this.props;

        return (
            <UnitsListRow>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('product_select')} TextAlign="center" />
                </UnitListColumnContainer>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('Quantity')} TextAlign="center" />
                </UnitListColumnContainer>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('Price')} TextAlign="center" />
                </UnitListColumnContainer>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('discount_percent')} TextAlign="center" />
                </UnitListColumnContainer>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('discount_amount')} TextAlign="center" />
                </UnitListColumnContainer>
                <UnitListColumnContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" NoMargin Text={t('total_price')} TextAlign="center" />
                </UnitListColumnContainer>
            </UnitsListRow>
        );
    }

    renderCreateContract = () => {
        var { t } = this.props;
        var { Device, CreateContractDetails } = this.props;
        var { SelectedOrganization, SelectedUserIds, SelectedUsers, TotalPrice } = this.state;

        return (
            <>
                <PageText FontFamily="medium" FontSize="large" JustifyContent="center" NoMargin Text={t('contracts_create')} TextAlign="center" />

                <Spacer Size="large" />

                <AssignClients
                    // GetStartedEligible="Meals"
                    HideSelectAll
                    // HideTitle
                    // HorizontalScroll={false}
                    MaxClients={1}
                    OnSelectClients={Users => this.onSelectClients(Users)}
                    SelectedUserIds={SelectedUserIds}
                    SelectedUsers={SelectedUsers}
                />

                <Spacer Size="small" />

                <PageText FontColorHover="black-hover" FontFamily="medium-italic" FontSize="small" JustifyContent="center" NoMargin OnClick={() => this.onToggleShowNonAbelUserInfoModal(true)} Text={t('contract_steps_for_non_abel_user_question')} TextAlign="center" />

                <Spacer Size="large" />

                {
                    !!CreateContractDetails.Organizations.length &&
                    <>
                        <PageText FontFamily="medium" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('made_collaboration_with')} TextAlign="center" />
                        
                        <Spacer Size="extra-small" />

                        {
                            (SelectedOrganization !== null && !!SelectedOrganization.OrgId) ?
                            <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="center" NoMargin Text={`${SelectedOrganization.OrgName} - ${SelectedOrganization.BranchName}`} TextAlign="center" />
                        :
                            <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="center" NoMargin Text={t('no_organizations')} TextAlign="center" />
                        }

                        <Spacer Size="extra-small" />

                        <ButtonGroup
                            Buttons={[{ Icon: Edit, IconPosition: 'left', FontFamily: 'semibold', FontSize: 'medium-1', OnClick: () => this.onToggleShowChooseOrganizationModal(true), Size: 'small', Title: t('edit_with_first_char_uppercase') }]}
                            ButtonWidth="fit-content"
                            NotTouching
                        />

                        <Spacer Size={Device === 'laptop' || Device === 'ipad' ? 'extra-large' : 'large'} />
                    </>
                }

                <PageText FontFamily="medium" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('contract_preview')} TextAlign="center" />

                <Spacer Size="small" />

                {this.renderLegal()}

                <Spacer Size={Device === 'laptop' || Device === 'ipad' ? 'extra-large' : 'large'} />

                {this.renderContractProducts()}

                {
                    !!+TotalPrice > 0 && 
                    <>
                        <Spacer Size={Device === 'laptop' || Device === 'ipad' ? 'extra-large' : 'large'} />

                        {this.renderPayment()}

                        <Spacer Size="medium" />

                        <PageText FontFamily="medium-italic" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('contracts_preview_on_next_page')} TextAlign="center" />
                    </>
                }
            </>
        );
    }

    renderInvoiceDateShortcuts = () => {
        var { t } = this.props;
        var { DateShortcuts, DateShortcuts_Selected } = this.state;

        var DefaultWeekdays = Array.apply(null, Array(7)).map((_, i) => moment(i, 'e').startOf('week').isoWeekday(i + 1).format('dd'));

        return (
            <DateShortcutsContainer className="DateShortcutsContainer">
                <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('contracts_invoices_date_shortcuts')} TextAlign="left" />

                <Spacer Size="extra-small" />

                <DateShortcutContainer className="DateShortcutContainer">
                    <DateShortcutCheckbox className="DateShortcutCheckbox" onClick={() => this.onSelectDateShortcut('Monthly_ThisMonth')} Selected={DateShortcuts_Selected === 'Monthly_ThisMonth'} />
                    <DateShortcutTextContainer className="DateShortcutTextContainer">
                        {t('the_for_numbers')}
                        &nbsp;
                        <DateShortcutInput
                            FontFamily="semibold"
                            FontSize="medium-1"
                            NoDecimal
                            NoLabel
                            NoMargin
                            OnBlur={event => this.onBlurDateShortcut({ event, DateShortcut: 'Monthly_ThisMonth' })}
                            OnChange={event => this.onChangeDateShortcut({ event, DateShortcut: 'Monthly_ThisMonth' })}
                            Placeholder="0"
                            ReadOnly={DateShortcuts_Selected !== 'Monthly_ThisMonth'}
                            Type="number"
                            Value={DateShortcuts.Monthly_ThisMonth.DateNumber}
                        />
                        {t('the_for_numbers_suffix', { returnObjects: true })[DateShortcuts.Monthly_ThisMonth.DateNumber ? DateShortcuts.Monthly_ThisMonth.DateNumber <= 31 ? DateShortcuts.Monthly_ThisMonth.DateNumber : 0 : 0].suffix}
                        &nbsp;
                        {t('of_every_month_this_month')}
                    </DateShortcutTextContainer>
                </DateShortcutContainer>
                <DateShortcutContainer className="DateShortcutContainer">
                    <DateShortcutCheckbox className="DateShortcutCheckbox" onClick={() => this.onSelectDateShortcut('Monthly_NextMonth')} Selected={DateShortcuts_Selected === 'Monthly_NextMonth'} />
                    <DateShortcutTextContainer className="DateShortcutTextContainer">
                        {t('the_for_numbers')}
                        &nbsp;
                        <DateShortcutInput
                            FontFamily="semibold"
                            FontSize="medium-1"
                            NoDecimal
                            NoLabel
                            NoMargin
                            OnBlur={event => this.onBlurDateShortcut({ event, DateShortcut: 'Monthly_NextMonth' })}
                            OnChange={event => this.onChangeDateShortcut({ event, DateShortcut: 'Monthly_NextMonth' })}
                            Placeholder="0"
                            ReadOnly={DateShortcuts_Selected !== 'Monthly_NextMonth'}
                            Type="number"
                            Value={DateShortcuts.Monthly_NextMonth.DateNumber}
                        />
                        {t('the_for_numbers_suffix', { returnObjects: true })[DateShortcuts.Monthly_NextMonth.DateNumber ? DateShortcuts.Monthly_NextMonth.DateNumber <= 31 ? DateShortcuts.Monthly_NextMonth.DateNumber : 0 : 0].suffix}
                        &nbsp;
                        {t('of_every_month_next_month')}
                    </DateShortcutTextContainer>
                </DateShortcutContainer>
                <DateShortcutContainer className="DateShortcutContainer">
                    <DateShortcutCheckbox className="DateShortcutCheckbox" onClick={() => this.onSelectDateShortcut('Weekly_ThisWeek')} Selected={DateShortcuts_Selected === 'Weekly_ThisWeek'} />
                    <DateShortcutTextContainer className="DateShortcutTextContainer" HasExtraContainer>
                        <DateShortcutSubContainer>
                            {t('every')}
                            &nbsp;
                            <DateShortcutInput
                                FontFamily="semibold"
                                FontSize="medium-1"
                                NoDecimal
                                NoLabel
                                NoMargin
                                OnBlur={event => this.onBlurDateShortcut({ event, DateShortcut: 'Weekly_ThisWeek' })}
                                OnChange={event => this.onChangeDateShortcut({ event, DateShortcut: 'Weekly_ThisWeek' })}
                                Placeholder="0"
                                ReadOnly={DateShortcuts_Selected !== 'Weekly_ThisWeek'}
                                Type="number"
                                Value={DateShortcuts.Weekly_ThisWeek.NumWeeks}
                            />
                            &nbsp;
                            {t('weeks_start_this_week')}
                        </DateShortcutSubContainer>
                        <DayOptionsContainer className="DayOptionsContainer">
                            {DefaultWeekdays.map((DayAbbr, DayIndex) => <DayOptionContainer className="DayOptionContainer" key={DayIndex} Disabled={DateShortcuts_Selected !== 'Weekly_ThisWeek'} onClick={DateShortcuts_Selected !== 'Weekly_ThisWeek' ? () => null : () => this.onSelectWeekStartingDay({ DateShortcut: 'Weekly_ThisWeek', DayIndex })} Selected={DateShortcuts.Weekly_ThisWeek.StartingDay === DayIndex}><PageText FontFamily="medium" FontSize="medium-1" JustifyContent="center" NoMargin Text={DayAbbr} TextAlign="center" /></DayOptionContainer> )}
                        </DayOptionsContainer>
                    </DateShortcutTextContainer>
                </DateShortcutContainer>
                <DateShortcutContainer className="DateShortcutContainer">
                    <DateShortcutCheckbox className="DateShortcutCheckbox" onClick={() => this.onSelectDateShortcut('Weekly_NextWeek')} Selected={DateShortcuts_Selected === 'Weekly_NextWeek'} />
                    <DateShortcutTextContainer className="DateShortcutTextContainer" HasExtraContainer>
                        <DateShortcutSubContainer>
                            {t('every')}
                            &nbsp;
                            <DateShortcutInput
                                FontFamily="semibold"
                                FontSize="medium-1"
                                NoDecimal
                                NoLabel
                                NoMargin
                                OnBlur={event => this.onBlurDateShortcut({ event, DateShortcut: 'Weekly_NextWeek' })}
                                OnChange={event => this.onChangeDateShortcut({ event, DateShortcut: 'Weekly_NextWeek' })}
                                Placeholder="0"
                                ReadOnly={DateShortcuts_Selected !== 'Weekly_NextWeek'}
                                Type="number"
                                Value={DateShortcuts.Weekly_NextWeek.NumWeeks}
                            />
                            &nbsp;
                            {t('weeks_start_next_week')}
                        </DateShortcutSubContainer>
                        <DayOptionsContainer className="DayOptionsContainer">
                            {DefaultWeekdays.map((DayAbbr, DayIndex) => <DayOptionContainer className="DayOptionContainer" key={DayIndex} Disabled={DateShortcuts_Selected !== 'Weekly_NextWeek'} onClick={DateShortcuts_Selected !== 'Weekly_NextWeek' ? () => null : () => this.onSelectWeekStartingDay({ DateShortcut: 'Weekly_NextWeek', DayIndex })} Selected={DateShortcuts.Weekly_NextWeek.StartingDay === DayIndex}><PageText FontFamily="medium" FontSize="medium-1" JustifyContent="center" NoMargin Text={DayAbbr} TextAlign="center" /></DayOptionContainer> )}
                        </DayOptionsContainer>
                    </DateShortcutTextContainer>
                </DateShortcutContainer>
            </DateShortcutsContainer>
        );
    }

    renderInvoices = () => {
        var { t } = this.props;
        var { Device } = this.props;
        var { ContractCurrency: { CurrencySign }, InvoicePaymentType, InvoiceSplitUp, Invoices_OneTime, Invoices_SplitUp, TotalInvoicePrice, TotalPrice } = this.state;

        if (!InvoicePaymentType || (InvoicePaymentType === 'SplitUp' && !+InvoiceSplitUp)) return null;

        var Invoices = InvoicePaymentType === 'OneTime' ? Invoices_OneTime : Invoices_SplitUp;

        var TitleText = InvoicePaymentType === 'OneTime' ? t('payment_choose_deadline_date') : t('payment_choose_deadline_date_and_prices');

        return (
            <>
                <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text={TitleText} TextAlign="center" />

                <Spacer Size="medium" />

                {
                    InvoicePaymentType === 'SplitUp' &&
                    <>
                        {this.renderInvoiceDateShortcuts()}

                        <Spacer Size="medium" />
                    </>
                }

                {
                    +TotalInvoicePrice !== +TotalPrice &&
                    <>
                        <PageText FontColor="red-bittersweet" FontFamily="medium-italic" FontSize="small" JustifyContent="center" NoMargin NoWrap Text={t('contracts_invoice_total_price_not_matching')} TextAlign="center" />

                        <Spacer Size="extra-small" />
                    </>
                }

                <InvoicesContainer className="InvoicesContainer">
                    {
                        Invoices.map(({ Amount, AmountText, InvoiceSentDate, PaymentDueDate }, InvoiceIndex) => {
                            var IsPaymentDateBeforeSentDate = moment(PaymentDueDate).format('YYYY-MM-DD') < moment(InvoiceSentDate).format('YYYY-MM-DD');

                            var DaysNumber_InvoiceSentDate = moment(InvoiceSentDate).diff(moment().format('YYYY-MM-DD'), 'days');
                            var DaysNumber_PaymentDueDate = moment(PaymentDueDate).diff(moment().format('YYYY-MM-DD'), 'days');

                            return (
                                <InvoiceContainer className="InvoiceContainer" key={InvoiceIndex}>
                                    {InvoicePaymentType === 'SplitUp' && <PageText FontFamily="bold" FontSize="small" JustifyContent={Device === 'laptop' ? 'flex-start' : 'center'} NoMargin NoWrap Text={t('contracts_invoice_part_number', { PartNumber: InvoiceIndex + 1 })} TextAlign={Device === 'laptop' ? 'left' : 'center'} />}
                                    <InvoiceAmountContainer className="InvoiceAmountContainer" HasError={!+Amount}>
                                        {
                                            InvoicePaymentType === 'OneTime' ?
                                            <>
                                                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Price')}:`} TextAlign="left" />
                                                <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={AmountText} TextAlign="left" />
                                            </>
                                        :
                                            <>
                                                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('contracts_invoice_amount')}:`} TextAlign="left" />
                                                <StyledAmountInput
                                                    InputFontFamily="medium"
                                                    InputFontSize="medium-1"
                                                    InputWidth="100%"
                                                    LabelFontFamily="medium"
                                                    LabelFontSize="medium-1"
                                                    Label={CurrencySign}
                                                    OnBlur={event => this.onBlurInvoiceAmount({ event, InvoiceIndex })}
                                                    OnChange={event => this.onChangeInvoiceAmount({ event, InvoiceIndex })}
                                                    Placeholder="0"
                                                    Type="number"
                                                    Value={Amount}
                                                />
                                            </>
                                        }
                                    </InvoiceAmountContainer>
                                    <InvoiceDateContainer>
                                        <InvoiceDateSubContainer>
                                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('contracts_invoice_will_be_sent')}:`} TextAlign="left" />
                                            <InvoiceDateButtonContainer IsPaymentDateBeforeSentDate={IsPaymentDateBeforeSentDate} onClick={() => this.onToggleShowChooseDatesModal({ EditingDate: { DateType: 'InvoiceSentDate', InvoiceIndex }, ShowChooseDatesModal: true })}>
                                                <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={moment(InvoiceSentDate).format('[NumbersDate]')} TextAlign="left" />
                                            </InvoiceDateButtonContainer>
                                        </InvoiceDateSubContainer>
                                        <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('in_days', { DaysNumber: DaysNumber_InvoiceSentDate })} TextAlign="left" />
                                    </InvoiceDateContainer>
                                    <InvoiceDateContainer>
                                        <InvoiceDateSubContainer>
                                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('contracts_invoice_deadline_date')}:`} TextAlign="left" />
                                            <InvoiceDateButtonContainer IsPaymentDateBeforeSentDate={IsPaymentDateBeforeSentDate} onClick={() => this.onToggleShowChooseDatesModal({ EditingDate: { DateType: 'PaymentDueDate', InvoiceIndex }, ShowChooseDatesModal: true })}>
                                                <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={moment(PaymentDueDate).format('[NumbersDate]')} TextAlign="left" />
                                            </InvoiceDateButtonContainer>
                                        </InvoiceDateSubContainer>
                                        <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('in_days', { DaysNumber: DaysNumber_PaymentDueDate })} TextAlign="left" />
                                    </InvoiceDateContainer>
                                </InvoiceContainer>
                            );
                        })
                    }
                </InvoicesContainer>
            </>
        );
    }

    renderInvoicesPreview = () => {
        var { t } = this.props;
        var { InvoicePaymentType, InvoiceSplitUp, Invoices_OneTime, Invoices_SplitUp } = this.state;

        var NumPayments = InvoicePaymentType === 'OneTime' ? 1 : InvoiceSplitUp;
        var Invoices = InvoicePaymentType === 'OneTime' ? [ ...Invoices_OneTime ] : [ ...Invoices_SplitUp ];

        return (
            <>
                <PageText FontFamily="semibold" FontSize="medium-2" JustifyContent="flex-start" NoMargin Text={t('payment_terms')} TextAlign="left" />

                <Spacer Size="small" />

                <MultiText
                    Texts={[
                        { FontFamily: 'medium', FontSize: 'medium-1', Text: t('payments_split_into') },
                        { FontFamily: 'semibold', FontSize: 'medium-1', Text: `${NumPayments} ${t('payment', { count: +NumPayments }).toLowerCase()}` }
                    ]}
                />

                <Spacer Size="small" />

                <InvoicePreviewContainer className="InvoicePreviewContainer">
                    {
                        Invoices.map(({ AmountText, PaymentDueDate }, InvoiceIndex) => {
                            return (
                                <InvoicePreviewSubContainer className="InvoicePreviewSubContainer" key={InvoiceIndex}>
                                    {InvoicePaymentType === 'SplitUp' && <StyledPaymentNumberPageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin NoWrap Text={`${t('contracts_invoice_part_number', { PartNumber: InvoiceIndex + 1 })}:`} TextAlign="left" />}

                                    <InvoicePreviewAmountContainer className="InvoicePreviewAmountContainer">
                                        <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Price')}:`} TextAlign="left" WhiteSpace="nowrap" />
                                        <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={AmountText} TextAlign="left" WhiteSpace="nowrap" />
                                    </InvoicePreviewAmountContainer>
                                    <InvoicePreviewDateContainer>
                                        <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('contracts_invoice_deadline_date')}:`} TextAlign="left" WhiteSpace="nowrap" />
                                        <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={moment(PaymentDueDate).format('[NumbersDate]')} TextAlign="left" WhiteSpace="nowrap" />
                                    </InvoicePreviewDateContainer>
                                </InvoicePreviewSubContainer>
                            );
                        })
                    }
                </InvoicePreviewContainer>

                <Spacer Size="small" />

                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('payment_made_through_abel')} TextAlign="left" />
            </>
        );
    }

    renderLegal = () => {
        var { t } = this.props;
        var { HealthDeclarations } = this.props.CreateContractDetails;
        var { AccuracyStatement, TermsConditions } = this.state;

        return (
            <>
                <PageText FontFamily="semibold" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('health_declarations')} TextAlign="center" />

                <Spacer Size="small" />

                <HealthDeclarationsContainer className="HealthDeclarationsContainer">
                    <HealthDeclarationContainer className="HealthDeclarationContainer">
                        <HealthDeclarationTextContainer className="HealthDeclarationTextContainer" />
                        <HealthDeclarationOptionsContainer className="HealthDeclarationOptionsContainer">
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="center" NoMargin Text={t('yes_with_first_char_uppercase')} TextAlign="center" Uppercase />
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="center" NoMargin Text={t('no_with_first_char_uppercase')} TextAlign="center" Uppercase />
                        </HealthDeclarationOptionsContainer>
                    </HealthDeclarationContainer>
                    {
                        HealthDeclarations.map(({ DeclarationId, Declaration }, DeclarationIndex) => {
                            return (
                                <HealthDeclarationContainer className="HealthDeclarationContainer" key={DeclarationId}>
                                    <HealthDeclarationTextContainer className="HealthDeclarationTextContainer">
                                        <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${DeclarationIndex + 1}. ${Declaration}`} TextAlign="left" />
                                    </HealthDeclarationTextContainer>
                                    <HealthDeclarationOptionsContainer className="HealthDeclarationOptionsContainer">
                                        <FakeCheckmarkBox className="FakeCheckmarkBox" />
                                        <FakeCheckmarkBox className="FakeCheckmarkBox" />
                                    </HealthDeclarationOptionsContainer>
                                </HealthDeclarationContainer>
                            );
                        })
                    }
                </HealthDeclarationsContainer>

                <Spacer Size="small" />

                <TermsConditionsContainer>{AccuracyStatement}</TermsConditionsContainer>

                <Spacer Size="medium" />

                <PageText FontFamily="semibold" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('other_general_terms')} TextAlign="center" />

                <Spacer Size="small" />

                <TermsConditionsContainer>{TermsConditions}</TermsConditionsContainer>
            </>
        );
    }

    renderNonAbelUserInfoModal = () => {
        var { ShowNonAbelUserInfoModal } = this.state;

        if (ShowNonAbelUserInfoModal) {
            return (
                <Info
                    InformationRenderer={this.renderNonAbelUserInfoModal_Information}
                    OnHide={() => this.onToggleShowNonAbelUserInfoModal(false)}
                    Show={ShowNonAbelUserInfoModal}
                />
            );
        }
    }

    renderNonAbelUserInfoModal_Information = () => {
        var { t } = this.props;

        return (
            <NonAbelUserInfoModalInformationContainer className="NonAbelUserInfoModalInformationContainer">
                {
                    NonAbelUserContractSteps.map((StringName, index) => {
                        return (
                            <React.Fragment key={index}>
                                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${index + 1}. ${t(StringName)}`} TextAlign="left" />
                                
                                <Spacer Size="small" />
                            </React.Fragment>
                        );
                    })
                }

                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('contract_steps_for_non_abel_user_final')} TextAlign="left" />
            </NonAbelUserInfoModalInformationContainer>
        );
    }

    renderPayment = () => {
        var { t } = this.props;
        var { InvoicePaymentType, InvoiceSplitUp } = this.state;

        var ButtonData = { BackgroundColorHover: 'blue-astronaut', ColorHover: 'white' };

        return (
            <>
                <OptionalLine>
                    <PageText ElementType="span" FontColor="gray-silver" FontFamily="bold" FontSize="medium-3" NoMargin Text={t('payment')} TextAlign="center" />
                </OptionalLine>

                <Spacer Size="medium" />

                <ButtonGroup
                    ButtonWidth="fit-content"
                    Buttons={[
                        { ...ButtonData, OnClick: () => this.onToggleInvoicePaymentType('OneTime'), Selected: InvoicePaymentType === 'OneTime', Title: t('payments_all_at_once') },
                        { ...ButtonData, OnClick: () => this.onToggleInvoicePaymentType('SplitUp'), Selected: InvoicePaymentType === 'SplitUp', Title: t('payments_split_into_parts') }
                    ]}
                />

                <Spacer Size={'large'} />

                {
                    InvoicePaymentType === 'SplitUp' &&
                    <>
                        <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin NoWrap Text={t('contracts_invoice_split_into')} TextAlign="center" />

                        <Spacer Size="extra-extra-small" />

                        <StyledSplitUpInput
                            FontFamily="medium"
                            FontSize="medium-1"
                            NoDecimal
                            NoLabel1
                            NoMargin
                            OnBlur={this.onBlurInvoiceSplitUp}
                            OnChange={this.onChangeInvoiceSplitUp}
                            Placeholder="0"
                            Type="number"
                            Value={InvoiceSplitUp}
                        />

                        <Spacer Size={'large'} />
                    </>
                }

                {this.renderInvoices()}
            </>
        );
    }

    renderProductsPreview = () => {
        var { t } = this.props;
        var { Device } = this.props;
        var { ContractProducts, TotalPriceText } = this.state;

        return (
            <>
                {
                    Device === 'laptop' ?
                    <ProductsListTableContainer>
                        <ProductsListTableRowContainer>
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('product')} TextAlign="left" />
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('Quantity')} TextAlign="left" />
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('Price')} TextAlign="left" />
                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={t('Discount')} TextAlign="left" />
                        </ProductsListTableRowContainer>
                        {
                            Object.entries(ContractProducts).map(([ ContractProductsKey, { CurrencySign, DiscountAmount, DiscountPercent, DiscountType, Price, ProductId, ProductName, Quantity, SignUsed } ]) => {
                                return (
                                    <ProductsListTableRowContainer key={ProductId}>
                                        <DetailText>{ProductName}</DetailText>
                                        <DetailText>{`${Quantity}`}</DetailText>
                                        <DetailText>{RenderCurrencyText({ CurrencySign, Price, SignUsed })}</DetailText>
                                        <DetailText>{DiscountType ? DiscountType === 'Amount' ? RenderCurrencyText({ CurrencySign, Price: DiscountAmount, SignUsed }) : `${DiscountPercent}%` : t('none_with_first_char_uppercase')}</DetailText>
                                    </ProductsListTableRowContainer>
                                );
                            })
                        }
                    </ProductsListTableContainer>
                :
                    <ProductsListBlocksContainer>
                        {
                            Object.entries(ContractProducts).map(([ ContractProductsKey, { CurrencySign, DiscountAmount, DiscountPercent, DiscountType, Price, ProductId, ProductName, Quantity, SignUsed } ]) => {
                                return (
                                    <ProductsListBlockContainer key={ProductId}>
                                        <ProductsListBlockRowContainer>
                                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('product')}:`} TextAlign="left" />
                                            <DetailText>{ProductName}</DetailText>
                                        </ProductsListBlockRowContainer>
                                        <ProductsListBlockRowContainer>
                                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Quantity')}:`} TextAlign="left" />
                                            <DetailText>{`${Quantity}`}</DetailText>
                                        </ProductsListBlockRowContainer>
                                        <ProductsListBlockRowContainer>
                                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Price')}:`} TextAlign="left" />
                                            <DetailText>{RenderCurrencyText({ CurrencySign, Price, SignUsed })}</DetailText>
                                        </ProductsListBlockRowContainer>
                                        <ProductsListBlockRowContainer>
                                            <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Discount')}:`} TextAlign="left" />
                                            <DetailText>{DiscountType ? DiscountType === 'Amount' ? RenderCurrencyText({ CurrencySign, Price: DiscountAmount, SignUsed }) : `${DiscountPercent}%` : t('none_with_first_char_uppercase')}</DetailText>
                                        </ProductsListBlockRowContainer>
                                    </ProductsListBlockContainer>
                                );
                            })
                        }
                    </ProductsListBlocksContainer>
                }

                <Spacer Size="extra-small" />

                <ProductsListBlockRowContainer>
                    <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('total_price')}:`} TextAlign="left" />
                    <DetailText FontFamily="bold" Underline>{TotalPriceText}</DetailText>
                </ProductsListBlockRowContainer>

                <Spacer Size="medium" />

                <ProductDescriptionsContainer>
                    {
                        Object.entries(ContractProducts).map(([ ContractProductsKey, { ProductId, ProductDescription, ProductName } ]) => {
                            return (
                                <ProductDescriptionContainer key={ProductId}>
                                    <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('product_description')} ${ProductName}:`} TextAlign="left" />
                                    
                                    <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={ProductDescription} TextAlign="left" />
                                </ProductDescriptionContainer>
                            );
                        })
                    }
                </ProductDescriptionsContainer>
            </>
        );
    }

    renderShowChooseDatesModal = () => {
        var { EditingDate: { DateType, InvoiceIndex }, InvoicePaymentType, ShowChooseDatesModal } = this.state;

        if (ShowChooseDatesModal) {
            var { t } = this.props;
            var SelectedDate = moment(this.state[`Invoices_${InvoicePaymentType}`][InvoiceIndex][DateType]).format('YYYY-MM-DD');

            return (
                <ChooseDates
                    DisabledMaxDate={DateType === 'InvoiceSentDate' ? moment(this.state[`Invoices_${InvoicePaymentType}`][InvoiceIndex].PaymentDueDate).format('YYYY-MM-DD') : ''}
                    DisabledMinDate={moment().format('YYYY-MM-DD')}
                    DisabledReason={t(DateType === 'InvoiceSentDate' ? 'contracts_invoice_sent_disabled_reason' : 'contracts_invoice_deadline_date_disabled_reason')}
                    MaxDates={1}
                    OnHide={() => this.onToggleShowChooseDatesModal({ EditingDate: { ...INITIAL_EDITINGDATE }, ShowChooseDatesModal: false })}
                    OnSelectDates={SelectedDates => this.onSelectDates(SelectedDates)}
                    RequiredDate
                    SelectedDates={[ SelectedDate ]}
                    Show={ShowChooseDatesModal}
                />
            );
        }
    }

    renderShowChooseOrganizationModal = () => {
        var { SelectedOrganization, ShowChooseOrganizationModal } = this.state;

        if (ShowChooseOrganizationModal) {
            return (
                <ChooseOrganization
                    OnHide={() => this.onToggleShowChooseOrganizationModal(false)}
                    OnSelectOrganization={Organization => this.onSelectOrganization(Organization)}
                    Organizations={this.props.CreateContractDetails.Organizations}
                    SelectedOrganization={SelectedOrganization}
                    Show={ShowChooseOrganizationModal}
                />
            );
        }
    }

    render() {
        var { t } = this.props;
        var { TryingCreateContract } = this.props;
        var { ContractProducts, InvoicePaymentType, Invoices_OneTime, Invoices_SplitUp, SelectedUsers, ShowContractPreview, TotalInvoicePrice, TotalPrice, TrainerSigned } = this.state;

        var Breadcrumbs = [{ Name: t('contracts_create') }];
        var Disabled = false;
        if (Object.entries(ContractProducts).length === 0) Disabled = true;
        else if (!SelectedUsers.length) Disabled = true;
        else if (!+TotalPrice || !+TotalInvoicePrice) Disabled = true;
        else if (+TotalInvoicePrice !== +TotalPrice) Disabled = true;
        else if (!InvoicePaymentType) Disabled = true;
        else if (InvoicePaymentType === 'OneTime') {
            for (i = 0; i < Invoices_OneTime.length; i++) {
                if (Invoices_OneTime[i].PaymentDueDate < Invoices_OneTime[i].InvoiceSentDate) {
                    Disabled = true;
                    break;
                }
            }
        }
        else if (InvoicePaymentType === 'SplitUp') {
            for (i = 0; i < Invoices_SplitUp.length; i++) {
                if (Invoices_SplitUp[i].PaymentDueDate < Invoices_SplitUp[i].InvoiceSentDate) {
                    Disabled = true;
                    break;
                }
            }
        }

        var SubmitButtonProps = { Disabled, OnClick: this.onClickPreviewContract, Title: t('next_with_first_char_uppercase') };
        if (ShowContractPreview) {
            Disabled = Disabled || !TrainerSigned;

            SubmitButtonProps = { Buttons: { ButtonOne: { Disabled: false, OnClick: () => this.onToggleShowContractPreview(false), Title: t('back_with_first_char_uppercase') }, ButtonTwo: { Disabled, OnClick: this.onCreateContract, Title: t('contracts_create_send') } }, SplitButtons: true }
        }

        if (this.state.Loading) return <Loading />;

        return (
            <>
                {TryingCreateContract && <Loading />}

                <Page renderBreadcrumbs={Breadcrumbs} renderSubmitButton={SubmitButtonProps}>
                    {ShowContractPreview ? this.renderContractPreview() : this.renderCreateContract()}
                </Page>

                {this.renderNonAbelUserInfoModal()}
                {this.renderShowChooseDatesModal()}
                {this.renderShowChooseOrganizationModal()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,

        UserDetails: state.Auth.UserDetails,

        CreateContractDetails: state.Sales.CreateContractDetails,

        TryingCreateContract: state.Sales.TryingCreateContract,
        TryingCreateContractError: state.Sales.TryingCreateContractError,
        TryingGetCreateContractDetails: state.Sales.TryingGetCreateContractDetails,
        TryingGetCreateContractDetailsError: state.Sales.TryingGetCreateContractDetailsError
    };
};

export default withTranslation()(connect(mapStateToProps, { ClearCreateContractDetails, CreateContract, GetCreateContractDetails } )(AddContract));